import React, { ReactNode } from 'react';
import { ContentBlock, ContentState } from 'draft-js';
import { EditorPlugin } from '@draft-js-plugins/editor';

export const LINK_ENTITY = 'LINK';

// Only web links and in-app hash router links, anything else (javascript:, data:, ...) renders as plain text
export function isSafeLinkUrl(url: unknown): url is string {
    return typeof url === 'string' && /^(https?:\/\/|#\/)/i.test(url);
}

function findLinkEntities(
    block: ContentBlock,
    callback: (start: number, end: number) => void,
    contentState: ContentState
) {
    block.findEntityRanges((character) => {
        const entityKey = character.getEntity();
        return entityKey !== null && contentState.getEntity(entityKey).getType() === LINK_ENTITY;
    }, callback);
}

type LinkProps = {
    contentState: ContentState;
    entityKey: string;
    children: ReactNode;
};

const Link = ({ contentState, entityKey, children }: LinkProps) => {
    const { url } = contentState.getEntity(entityKey).getData();
    if (!isSafeLinkUrl(url)) return <>{children}</>;

    return (
        <a
            href={url}
            target={url.startsWith('#/') ? undefined : '_blank'}
            rel="noreferrer"
            // Following a link should not also select the tile
            onClick={(e) => e.stopPropagation()}
        >
            {children}
        </a>
    );
};

export const createLinkPlugin = (): EditorPlugin => ({
    decorators: [{ strategy: findLinkEntities, component: Link }],
});
